import React, {lazy, Suspense,useState, useEffect, useRef, useContext} from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/App.css';
import Typography from '@mui/material/Typography';

//Components
import Navbar from './components/Navbar';
import {SoundContext} from './components/SoundContext';
import RecordPlayer from './components/RecordPlayer';
//Page components
import Homepage from './pages/Homepage';
import About from './pages/About';
import CommissionMe from './pages/CommissionMe';
import MyCV from './pages/MyCV';
import MyLinks from './pages/MyLinks';
import Contact from './pages/Contact';
//Project pages
//--dtiys
import { dtiysData} from "./components/projectData/Dtiys";

//--fan art
import {fanartData} from "./components/projectData/FanArt";
//-og projects
import { originalProjectsList} from "./components/projectData/OriginalProjects";
//import AnimeCharSheets from './pages/project-pages/ogproject-pages/AnimeCharSheets';

function App({onFontChange}) {
  
  const dtiysComponents = {
    ChallengeSilka: lazy(() => import('./pages/project-pages/dtiys-pages/ChallengeSilka')),
    ChallengeBellebubben: lazy(()=>import('./pages/project-pages/dtiys-pages/ChallengeBellebubben')),
    ChallengeCookysparks: lazy(()=>import('./pages/project-pages/dtiys-pages/ChallengeCookysparks')),
    ChallengeCyarine: lazy(()=>import('./pages/project-pages/dtiys-pages/ChallengeCyarine')),
    ChallengeNymeriaa: lazy(()=>import('./pages/project-pages/dtiys-pages/ChallengeNymeriaa')),
    ChallengeSquiddyInks: lazy(()=>import('./pages/project-pages/dtiys-pages/ChallengeSquiddyInks')),
    ChallengeArtbyrisotoo: lazy(()=>import('./pages/project-pages/dtiys-pages/ChallengeArtbyrisotoo')),
    ChallengeJorioux: lazy(()=>import('./pages/project-pages/dtiys-pages/ChallengeJorioux')),
  }
  const fanartComponents={
    AlexZombie: lazy(()=> import('./pages/project-pages/fanart-pages/AlexZombie')),
    Avatar: lazy(()=> import('./pages/project-pages/fanart-pages/Avatar')),
    EverAfterHigh: lazy(()=> import('./pages/project-pages/fanart-pages/EverAfterHigh')),
    HadesStyleStudy: lazy(()=> import('./pages/project-pages/fanart-pages/HadesStyleStudy')),
    MeButShow: lazy(()=> import('./pages/project-pages/fanart-pages/MeButShow')),
    MonsterHigh: lazy(()=> import('./pages/project-pages/fanart-pages/MonsterHigh')),
    NanacoStudy: lazy(()=> import('./pages/project-pages/fanart-pages/NanacoStudy')),
    OHTarotHunter: lazy(()=> import('./pages/project-pages/fanart-pages/OHTarotHunter')),
    PrincessAna: lazy(()=> import('./pages/project-pages/fanart-pages/PrincessAna')),
    TheudenRain: lazy(()=> import('./pages/project-pages/fanart-pages/TheudenRain')),
    WebtoonAC: lazy(()=> import('./pages/project-pages/fanart-pages/WebtoonAC'))
  }

  const originalProjectComponents = {
    ArtSquaredContest: lazy(()=>import('./pages/project-pages/ogproject-pages/ArtSquaredContest')),
    Backgrounds:lazy(()=>import('./pages/project-pages/ogproject-pages/Backgrounds')),
    ChiliGirl:lazy(()=>import('./pages/project-pages/ogproject-pages/ChiliGirl')),
    Delivery:lazy(()=>import('./pages/project-pages/ogproject-pages/Delivery')),
    EarringCollection:lazy(()=>import('./pages/project-pages/ogproject-pages/EarringCollection')),
    HoleFace:lazy(()=>import('./pages/project-pages/ogproject-pages/HoleFace')),
    MadnessBottle:lazy(()=>import('./pages/project-pages/ogproject-pages/MadnessBottle')),
    MeetMyChars:lazy(()=>import('./pages/project-pages/ogproject-pages/MeetMyChars')),
    Millicent:lazy(()=>import('./pages/project-pages/ogproject-pages/Millicent')),
    NolaStudy:lazy(()=>import('./pages/project-pages/ogproject-pages/NolaStudy')),
    Periwinkle:lazy(()=>import('./pages/project-pages/ogproject-pages/Periwinkle')),
    PublicFigurePortraits:lazy(()=>import('./pages/project-pages/ogproject-pages/PublicFigurePortraits')),
    SelfPortraitPurple:lazy(()=>import('./pages/project-pages/ogproject-pages/SelfPortraitPurple')),
    SpiderverseSelfPortrait:lazy(()=>import('./pages/project-pages/ogproject-pages/SpiderverseSelfPortrait')),
    StarryNightBall:lazy(()=>import('./pages/project-pages/ogproject-pages/StarryNightBall')),
    TimeTalk:lazy(()=>import('./pages/project-pages/ogproject-pages/TimeTalk')),
    VampireCards:lazy(()=>import('./pages/project-pages/ogproject-pages/VampireCards')),
    AnimeCharSheets: lazy(()=>import('./pages/project-pages/ogproject-pages/AnimeCharSheets'))
  }

  const [currFont,setCurrFont] = useState('MyHandwritten');

  const handleFontChange = (font) =>{
    setCurrFont(font);
    onFontChange(font);

    document.body.classList.remove('font-myhandwritten', 'font-lexend');
    document.body.classList.add(`font-${font.toLowerCase()}`);
  }

  const {isSoundOn} = useContext(SoundContext);//consume sound context so we can control music
  const [isPlaying, setIsPlaying] = useState(false);//default not playing
  const [volume,setVolume] = useState(0.4);

  const audioRef = useRef(null);

  useEffect(
    ()=>{
      if(!audioRef.current){
        audioRef.current = new Audio('/assets/audio/695951__m-murray__rainy-days-final-version-acousticpiano.wav');
        audioRef.current.loop = true;
        audioRef.current.load();

        audioRef.current.volume = volume;
      }
    },[volume]
  );

  useEffect(
    ()=>{
      if(audioRef.current){
        if(isPlaying && isSoundOn){
          audioRef.current.play().catch(e=> console.error("Audio playback error :(", e));
        }
        else{
          audioRef.current.pause();
        }
      }
      
    },[isPlaying, isSoundOn]
  );

  useEffect(()=>{
    console.log("Volume Effect triggered. Current volume:", volume);

    if(audioRef.current){
      audioRef.current.volume = volume;
    }
  },[volume]);//note how this changes based on change of volume

  const toggleMusic = ()=>{
    setIsPlaying(prevIsPlaying => {
      console.log("toggle music. Old isPlaying state: ",prevIsPlaying,"new isplaying: ", !prevIsPlaying);
      return !prevIsPlaying;
    } );
  };

  //handler for volume input
  const handleVolumeChange = (event)=>{
    const newVolume = parseFloat(event.target.value);//volume comes in as string
    setVolume(newVolume);
  }

  return (
    <div className={`App font-${currFont.toLowerCase()}`}>
      <Suspense fallback={<div>Loading components...</div>}>
        <Router>
          <Navbar onFontChange={handleFontChange} currFont ={currFont}/>
          <header className="App-header">
            
            <div className="App-maincontent">
              <Routes>
                {/*-- Main logistic pages --*/}
                <Route path="/pages/Homepage" element={<Homepage/>}/>
                <Route path="/pages/About" element={<About/>}/>
                <Route path="/pages/CommissionMe" element={<CommissionMe/>}/>
                <Route path="/pages/CV" element={<MyCV/>}/>
                <Route path="/pages/MyLinks" element={<MyLinks/>}/>
                <Route path="/pages/Contact" element={<Contact/>}/>
                {/*-- Project pages--*/}
                {/*---dtiys ---*/}
                {
                  dtiysData.map((item,index) =>{
                    const ProjectComponent = dtiysComponents[item.component];
                    //makes sure we actually have a component to work with
                    if(!ProjectComponent){
                      console.warn(`Component '${item.component}' not found in '${dtiysComponents}' map`);
                      return null;//render nothing if no component
                    }
                    return(
                      <Route
                        key={index}
                        path = {item.path}
                        element={<ProjectComponent/>}
                      />
                    )
                  })
                }
                {/*--- fan art --- */}
                {
                  fanartData.map((fanartitem,index) =>{
                    const FanartComponent = fanartComponents[fanartitem.component];
                    //do we have a component to work with?
                    if(!FanartComponent){
                      console.warn(`Component '${fanartitem.component}' not found in '${fanartComponents}' map`);
                      return null;
                    }
                    return(
                      <Route
                        key={index}
                        path={fanartitem.path}
                        element={<FanartComponent/>}
                      />
                    )
                  })
                }
                {/*--- original projects--- */}
                {
                  originalProjectsList.map((ogproject,index)=>{
                    const OgProjComponent = originalProjectComponents[ogproject.component];
                    //do we have a component to work with?
                    if(!OgProjComponent){
                      console.warn(`Component '${ogproject.component}' not found in '${originalProjectComponents}' map`);
                      return null;
                    }
                    return(
                      <Route
                        key={index}
                        path={ogproject.path}
                        element={<OgProjComponent/>}
                      />
                    )
                  })
                }

                {/*-- default --*/}
                <Route path="/" element={<Homepage/>}/>
              </Routes>
            </div>

            <div className="App-recordPlayer" onClick={toggleMusic}>
              <RecordPlayer
                soundState={isPlaying}
                altText={isPlaying ? "Record On" : "Record Off"}
              />
            </div>

            <label htmlFor="volume-slider">
                <Typography variant="body1">
                  Volume: 
                </Typography>
              
            </label>
            <input
              id="volume-slider"
              type="range"
              min="0"
              max="1"
              step="0.01"
              value={volume}
              onChange={handleVolumeChange}
            />
            <span>
                <Typography variant="body1">
                  {Math.round(volume * 100)}%
                </Typography>
              
            </span>

          </header>
        </Router>
      </Suspense>
      
    </div>
  );
}

export default App;
